import { NgModule } from '@angular/core';
import { STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { environment } from '@env/environment';
import { AppCrypto, AppSettingsService, AppStorage, LoggerFactory, NetworkService, NoAppEncryption, Utf8AppCrypto } from '@rillion/core';
import { AppInitializerService } from '@rillion/core/initializer/app-initializer.service';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { FormattingService } from '@rillion/core/services/formatting.service';
import { MapDatePipe } from '@rillion/shared/data-table/pipes/map-date.pipe';
import { MapNumberPipe } from '@rillion/shared/data-table/pipes/map-number.pipe';
import { MediaService } from '@rillion/core/services/media.service';

export function appCrypto(): AppCrypto {
  return environment.production ? new Utf8AppCrypto() : new NoAppEncryption();
}

@NgModule({
  declarations: [],
  exports: [],
  imports: [AngularSvgIconModule.forRoot()],
  providers: [
    AppStorage,
    AppSettingsService,
    AppInitializerService,
    LoggerFactory,
    NetworkService,
    MediaService,
    FormattingService,
    MapDatePipe,
    MapNumberPipe,
    {
      // Encryption service
      provide: AppCrypto,
      useFactory: appCrypto,
    },
    {
      provide: STEPPER_GLOBAL_OPTIONS,
      useValue: { showError: true },
    },
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class CoreModule {}
